import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useExportSocialHistoryToEncounter = () =>
  useMutationWithLoading(
    async (params: {
      patientUuid: string;
      appointmentUuid: string;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).exportSocialHistoryToEncounter(
        params.patientUuid,
        params.appointmentUuid,
        params.xTENANTID
      )
  );
